import { Link, useParams } from "react-router-dom";
import { ArrowLeft, ChevronRight, Store } from "lucide-react";
import { money, validityLabel } from "@/lib/api";
import { Empty, ErrorBox, PageHead, Spinner, useFetch } from "@/components/common";
import { BenefitList } from "@/pages/Enroll";

export default function Explore() {
  const { data, error, loading } = useFetch("/public/packages");
  return (
    <div>
      <PageHead eyebrow="Explore" title="Packages" sub="Care packages available from GIA Healthcare" />
      {loading && <Spinner />}
      <ErrorBox error={error} />
      {data?.length === 0 && <Empty title="No packages available yet" />}
      <div className="space-y-4">
        {data?.map((p, i) => (
          <Link key={p.id} to={`/app/explore/${p.slug}`} className={`rise rise-${i % 4} block overflow-hidden rounded-3xl border border-slate-100 bg-white shadow-sm transition-shadow hover:shadow-lg`} data-testid={`explore-package-${p.slug}`}>
            <div className="gradient-card p-5 text-white">
              <p className="text-lg font-extrabold">{p.name}</p>
              <p className="mt-1 line-clamp-2 text-xs text-white/75">{p.description}</p>
            </div>
            <div className="flex items-center justify-between p-4">
              <div>
                <p className="text-lg font-extrabold text-slate-900">{money(p.price, p.currency)}</p>
                <p className="text-xs text-slate-500">{p.benefits.length} benefits · {validityLabel(p.validity_value, p.validity_unit)}</p>
              </div>
              <ChevronRight className="text-purple-600" />
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}

export function ExploreDetail() {
  const { slug } = useParams();
  const { data: p, error, loading } = useFetch(`/public/packages/${slug}`);
  return (
    <div className="space-y-5">
      <Link to="/app/explore" className="btn-ghost btn-sm -ml-2" data-testid="explore-back"><ArrowLeft size={14} /> Packages</Link>
      {loading && <Spinner />}
      <ErrorBox error={error} />
      {p && (
        <>
          <div className="rise rounded-3xl gradient-card p-6 text-white shadow-xl">
            <h1 className="text-2xl font-extrabold" data-testid="explore-detail-name">{p.name}</h1>
            <p className="mt-2 text-sm text-white/80">{p.description}</p>
            <p className="mt-4 text-3xl font-extrabold">{money(p.price, p.currency)}</p>
            <p className="text-xs text-white/70">Valid {validityLabel(p.validity_value, p.validity_unit)} after verified activation</p>
          </div>
          <BenefitList benefits={p.benefits} />
          {p.eligibility_requirements && <div className="surface p-4 text-xs leading-relaxed text-slate-600"><p className="label">Eligibility</p>{p.eligibility_requirements}</div>}
          <div className="flex gap-3 rounded-2xl bg-blue-50 p-4 text-xs text-blue-900"><Store size={18} className="shrink-0" /> To enroll, purchase a physical card at an authorized GIA cashier. GIA will issue your account for that card.</div>
          {p.terms && <p className="text-[11px] text-slate-400">{p.terms}</p>}
        </>
      )}
    </div>
  );
}
